import script from "./pazienteMedicheEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./pazienteMedicheEdit.vue?vue&type=script&setup=true&lang=ts"

import "./pazienteMedicheEdit.vue?vue&type=style&index=0&id=500f91fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-500f91fb"]])

export default __exports__